/* STADTHOLZ Fliegen-Aufbau — schaltet die vier Schritte der Bühne um.
   Autoplay ca. 2,8 s je Schritt, letzter Schritt 4,2 s (SPEZIFIKATION §12b).
   Läuft nur, solange die Bühne sichtbar ist. Klick auf einen Schritt stoppt das Autoplay.
   prefers-reduced-motion: kein Autoplay, Endzustand bleibt stehen. Vanilla JS, keine Bibliothek. */

(function () {
  var STEP_MS = 2800;
  var LAST_MS = 4200;

  function setup(root) {
    if (root.__szFlbau) return;
    root.__szFlbau = true;

    var stage = root.querySelector('[data-flbau-stage]');
    var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-flbau-step]'));
    var textEl = root.querySelector('[data-flbau-text]');
    var toggle = root.querySelector('[data-flbau-toggle]');
    if (!stage || !buttons.length) return;

    var count = buttons.length;
    var step = count - 1;
    var timer = null;
    var playing = false;
    var visible = false;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var autoplay = root.getAttribute('data-autoplay') !== 'false';

    function show(index) {
      step = index;
      stage.setAttribute('data-step', String(index));
      buttons.forEach(function (btn, i) {
        var active = i === index;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      if (textEl) textEl.textContent = buttons[index].getAttribute('data-text') || '';
    }

    function updateToggle() {
      if (!toggle) return;
      toggle.textContent = playing ? 'Animation anhalten' : 'Animation abspielen';
    }

    function schedule() {
      clearTimeout(timer);
      if (!playing || !visible) return;
      timer = setTimeout(function () {
        show((step + 1) % count);
        schedule();
      }, step === count - 1 ? LAST_MS : STEP_MS);
    }

    function stop() {
      playing = false;
      clearTimeout(timer);
      // Erst nach Eingriff vorlesen lassen, sonst spricht der Screenreader bei jedem Autoplay-Schritt.
      if (textEl) textEl.setAttribute('aria-live', 'polite');
      updateToggle();
    }

    function play() {
      if (reduce) return;
      playing = true;
      if (textEl) textEl.setAttribute('aria-live', 'off');
      if (step === count - 1) show(0);
      updateToggle();
      schedule();
    }

    buttons.forEach(function (btn, i) {
      btn.addEventListener('click', function () {
        stop();
        show(i);
      });
    });

    if (toggle && !reduce) {
      toggle.hidden = false;
      toggle.addEventListener('click', function () {
        if (playing) {
          stop();
        } else {
          play();
        }
      });
    }

    if (reduce || !autoplay) {
      show(count - 1);
      updateToggle();
      return;
    }

    // Start auf Schritt 01, abspielen sobald sichtbar.
    show(0);
    playing = true;
    if (textEl) textEl.setAttribute('aria-live', 'off');
    updateToggle();

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            visible = entry.isIntersecting;
            if (visible) {
              schedule();
            } else {
              clearTimeout(timer);
            }
          });
        },
        { threshold: 0.35 }
      );
      io.observe(stage);
    } else {
      visible = true;
      schedule();
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        clearTimeout(timer);
      } else {
        schedule();
      }
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-sz-flbau]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    }, { once: true });
  } else {
    init();
  }

  // Theme-Editor: neu geladene Section initialisieren.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
